import {
    all,
    call,
    fork,
    put,
    takeEvery,
    takeLatest,
} from 'redux-saga/effects';
import * as messageAPI from '../api/messageAPI';
import {
    MODIFY_AUTOMESSAGE_FAILURE,
    MODIFY_AUTOMESSAGE_SUCCESS,
    MODIFY_AUTOMESSAGE,
    GET_AUTOMESSAGE_FAILURE,
    GET_AUTOMESSAGE_SUCCES,
    GET_AUTOMESSAGE,
    GET_MESSAGE_HISTORY,
    GET_MESSAGE_HISTORY_FAILURE,
    GET_MESSAGE_HISTORY_SUCCESS,
    GET_MONO_MESSAGE_HISTORY,
    GET_MONO_MESSAGE_HISTORY_SUCCESS,
    GET_MONO_MESSAGE_HISTORY_FAILURE,
    GET_MONO_MESSAGE_HISTORY_COUNT,
    GET_MONO_MESSAGE_HISTORY_COUNT_SUCCESS,
    GET_MONO_MESSAGE_HISTORY_COUNT_FAILURE,
    GET_CERTIFICATEDATA,
    GET_CERTIFICATEDATA_SUCCES,
    GET_CERTIFICATEDATA_FAILURE,
    GET_PUSH_NOTIFICATION_HISTORY,
    GET_PUSH_NOTIFICATION_HISTORY_SUCCESS,
    GET_PUSH_NOTIFICATION_HISTORY_FAILURE,
    GET_KAKAO_ALIM_TALK_HISTORY,
    GET_KAKAO_ALIM_TALK_HISTORY_SUCCESS,
    GET_KAKAO_ALIM_TALK_HISTORY_FAILURE,
    GET_KAKAO_ALIM_TALK_COUNT,
    GET_KAKAO_ALIM_TALK_COUNT_SUCCESS,
    GET_KAKAO_ALIM_TALK_COUNT_FAILURE,
    DELETE_RESERVED_MONO_MESSAGE,
    DELETE_RESERVED_MONO_MESSAGE_SUCCESS,
    DELETE_RESERVED_MONO_MESSAGE_FAILURE,
    GET_KAKAO_ALIM_TEMPLATES,
    GET_KAKAO_ALIM_TEMPLATES_SUCCESS,
    GET_KAKAO_ALIM_TEMPLATES_FAILURE,
    DELETE_AUTOMESSAGE_SUCCESS,
    DELETE_AUTOMESSAGE_FAILURE,
    DELETE_AUTOMESSAGE,
    CREATE_AUTOMESSAGE,
    CREATE_AUTOMESSAGE_FAILURE,
    CREATE_AUTOMESSAGE_SUCCESS,
} from '../reducers/message';

export default function* messageSaga() {
    function* getCertificateData(action) {
        try {
            const result = yield call(
                messageAPI.getCertificateToKTMessageServer,
                action.data,
            );

            yield put({
                type: GET_CERTIFICATEDATA_SUCCES,
                data: result.certificate_list,
            });
        } catch (err) {
            yield put({
                type: GET_CERTIFICATEDATA_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetCertificateData() {
        yield takeLatest(GET_CERTIFICATEDATA, getCertificateData);
    }
    /** 메시지 내역을 가져오는 함수 */
    function* getMessageHistory(action) {
        try {
            const result = yield call(
                messageAPI.getMessageHistory,
                action.data,
            );
            yield put({
                type: GET_MESSAGE_HISTORY_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_MESSAGE_HISTORY_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetMessageHistory() {
        yield takeLatest(GET_MESSAGE_HISTORY, getMessageHistory);
    }
    /** 메시지 내역을 가져오는 함수 (kt - mono 신) */
    function* getMonoMessageHistory(action) {
        try {
            const result = yield call(
                messageAPI.getMonoMessageHistory,
                action.data.params,
                action.data.type,
            );
            yield put({
                type: GET_MONO_MESSAGE_HISTORY_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_MONO_MESSAGE_HISTORY_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetMonoMessageHistory() {
        yield takeLatest(GET_MONO_MESSAGE_HISTORY, getMonoMessageHistory);
    }
    /** 메시지 내역 count를 가져오는 함수 (kt - mono 신) */
    function* getMonoMessageHistoryCount(action) {
        try {
            const result = yield call(
                messageAPI.getMonoMessageHistoryCount,
                action.data.params,
                action.data.type,
            );
            yield put({
                type: GET_MONO_MESSAGE_HISTORY_COUNT_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_MONO_MESSAGE_HISTORY_COUNT_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetMonoMessageHistoryCount() {
        yield takeLatest(
            GET_MONO_MESSAGE_HISTORY_COUNT,
            getMonoMessageHistoryCount,
        );
    }
    /** 푸시 알림 내역을 가져오는 함수 */
    function* getPushNotificationHistory(action) {
        try {
            const result = yield call(
                messageAPI.getPushNotificationHistory,
                action.data,
            );
            yield put({
                type: GET_PUSH_NOTIFICATION_HISTORY_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_PUSH_NOTIFICATION_HISTORY_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetPushNotificationHistory() {
        yield takeLatest(
            GET_PUSH_NOTIFICATION_HISTORY,
            getPushNotificationHistory,
        );
    }
    /** 알림톡 내역을 가져오는 함수 */
    function* getKakaoAlimTalkHistory(action) {
        try {
            const result = yield call(
                messageAPI.getKakaoAlimTalkHistory,
                action.data.params,
                action.data.type,
            );
            yield put({
                type: GET_KAKAO_ALIM_TALK_HISTORY_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_KAKAO_ALIM_TALK_HISTORY_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetKakaoAlimTalkHistory() {
        yield takeLatest(GET_KAKAO_ALIM_TALK_HISTORY, getKakaoAlimTalkHistory);
    }
    /** 알림톡 count를 가져오는 함수 */
    function* getKakaoAlimTalkCount(action) {
        try {
            const result = yield call(
                messageAPI.getKakaoAlimTalkCount,
                action.data.params,
                action.data.type,
            );
            yield put({
                type: GET_KAKAO_ALIM_TALK_COUNT_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_KAKAO_ALIM_TALK_COUNT_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetKakaoAlimTalkCount() {
        yield takeLatest(GET_KAKAO_ALIM_TALK_COUNT, getKakaoAlimTalkCount);
    }
    /** 알림톡 count를 가져오는 함수 */
    function* getKakaoAlimTalkTemplates() {
        try {
            const result = yield call(messageAPI.getKakaoTemplates);
            yield put({
                type: GET_KAKAO_ALIM_TEMPLATES_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_KAKAO_ALIM_TEMPLATES_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetKakaoAlimTalkTemplates() {
        yield takeLatest(GET_KAKAO_ALIM_TEMPLATES, getKakaoAlimTalkTemplates);
    }
    /** 문자 메세지 내역(신) > 예약 내역 삭제하는 함수 */
    function* deleteReservedMonoMessage(action) {
        try {
            const result = yield call(
                messageAPI.deleteReservedMonoMessage,
                action.data,
            );
            yield put({
                type: DELETE_RESERVED_MONO_MESSAGE_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: DELETE_RESERVED_MONO_MESSAGE_FAILURE,
                error: err,
            });
        }
    }
    function* watchdeleteReservedMonoMessage() {
        yield takeLatest(
            DELETE_RESERVED_MONO_MESSAGE,
            deleteReservedMonoMessage,
        );
    }
    function* getAutoMessageSetting(action) {
        try {
            const result = yield call(
                messageAPI.getAutoMessageSetting,
                action.data,
            );
            yield put({
                type: GET_AUTOMESSAGE_SUCCES,
                data: result,
            });
        } catch (err) {
            yield put({
                type: GET_AUTOMESSAGE_FAILURE,
                data: err,
            });
        }
    }
    function* watchGetAutoMessageSetting() {
        yield takeLatest(GET_AUTOMESSAGE, getAutoMessageSetting);
    }

    function* modifyAutoMessageSettig(action) {
        try {
            const result = yield call(
                messageAPI.modifyAutoMessageSettig,
                action.data,
            );
            yield put({
                type: MODIFY_AUTOMESSAGE_SUCCESS,
                data: result,
            });
        } catch (err) {
            console.log('err', err);
            yield put({
                type: MODIFY_AUTOMESSAGE_FAILURE,
                error: err,
            });
        }
    }
    function* watchModifyAutoMessageSettig() {
        yield takeLatest(MODIFY_AUTOMESSAGE, modifyAutoMessageSettig);
    }

    function* deleteAutoMessageSetting(action) {
        try {
            const result = yield call(
                messageAPI.deleteAutoMessageSetting,
                action.data,
            );
            yield put({
                type: DELETE_AUTOMESSAGE_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: DELETE_AUTOMESSAGE_FAILURE,
                data: err,
            });
        }
    }
    function* watchDeleteAutoMessageSetting() {
        yield takeLatest(DELETE_AUTOMESSAGE, deleteAutoMessageSetting);
    }

    function* createAutoMessage(action) {
        try {
            const result = yield call(
                messageAPI.createAutoMessage,
                action.data,
            );
            yield put({
                type: CREATE_AUTOMESSAGE_SUCCESS,
                data: result,
            });
        } catch (err) {
            yield put({
                type: CREATE_AUTOMESSAGE_FAILURE,
                error: err,
            });
        }
    }
    function* watchCreateAutoMessage() {
        yield takeLatest(CREATE_AUTOMESSAGE, createAutoMessage);
    }

    yield all([
        fork(watchModifyAutoMessageSettig),
        fork(watchGetAutoMessageSetting),
        fork(watchGetMessageHistory),
        fork(watchGetMonoMessageHistory),
        fork(watchGetMonoMessageHistoryCount),
        fork(watchGetCertificateData),
        fork(watchGetPushNotificationHistory),
        fork(watchGetKakaoAlimTalkHistory),
        fork(watchGetKakaoAlimTalkCount),
        fork(watchGetKakaoAlimTalkTemplates),
        fork(watchDeleteAutoMessageSetting),
        fork(watchCreateAutoMessage),
        fork(watchdeleteReservedMonoMessage),
    ]);
}
